// Burger Topping Images - using local images from /toppings/burger/
export const BURGER_TOPPING_IMAGES = {
  "Ketchup": "/toppings/burger/ketchup.png",
  "Mayo": "/toppings/burger/mayo.png",
  "Mustard": "/toppings/burger/mustard.png",
  "Onion": "/toppings/burger/onion.png",
  "Tomato": "/toppings/burger/tomato.png",
  "Pickles": "/toppings/burger/pickles.png",
  "Lettuce": "/toppings/burger/lettuce.png",
  "Jalapeño Pepper": "/toppings/burger/jalapeno peppers.png",
  "Cheese Slice": "/toppings/burger/cheese.png",
};

// Pizza Topping Images - using local images from /toppings/pizza/
export const PIZZA_TOPPING_IMAGES = {
  // Meats
  "Pepperoni": "/toppings/pizza/pepperoni.png",
  "Sausage": "/toppings/pizza/sausage.png",
  "Bacon": "/toppings/pizza/bacon.png",
  "Beef": "/toppings/pizza/beef.png",
  "Italian Sausage": "/toppings/pizza/sausage.png",
  // Veggies
  "Mushrooms": "/toppings/pizza/mushroom.png",
  "Mushroom": "/toppings/pizza/mushroom.png",
  "Onions": "/toppings/pizza/onion.png",
  "Onion": "/toppings/pizza/onion.png",
  "Green Peppers": "/toppings/pizza/bell peppers.png",
  "Green Bell Peppers": "/toppings/pizza/bell peppers.png",
  "Bell Peppers": "/toppings/pizza/bell peppers.png",
  "Black Olives": "/toppings/pizza/black olives.png",
  "Sliced Black Olives": "/toppings/pizza/black olives.png",
  "Jalapenos": "/toppings/pizza/jalapeno peppers.png",
  "Jalapeños": "/toppings/pizza/jalapeno peppers.png",
  "Banana Peppers": "/toppings/pizza/banana peppers.png",
  // Premium
  "Pineapple": "/toppings/pizza/pineapple.png",
};
